import React from 'react';
import ProtectedRoute from '../components/ProtectedRoute';
import DashboardLayout from '../components/DashboardLayout';
import AdminMentorList from '../components/AdminMentorList';

const AdminMentors = () => {
    return (
        <ProtectedRoute roles={['ADMIN']}>
            <DashboardLayout title="Mentor Management" roles={['ADMIN']}>
                <AdminMentorList />
            </DashboardLayout>
        </ProtectedRoute>
    );
};

export default AdminMentors;
